<template>
  <div :class="parentClass" ref="list">
    <template v-if="connected">
      <refresh @refresh-list="refreshList"/>
      <template
        v-if="((status === 'success' && streams.length > 0) || (status === 'waiting' && streams.length > 0)) || streams.length > 0"
      >
        <div class="vr360-app__all-streams">
          <ul class="vr360-app__all-streams__list">
            <item-public-stream v-for="item in streams" :stream="item" :key="item.id"></item-public-stream>
          </ul>
          <div class="vr360-spinner-small">
            <span v-if="status === 'waiting'"></span>
          </div>
        </div>
      </template>
      <template v-else-if="status === 'success' && streams.length === 0 && !search">
        <i class="vr360-icon bg-watched-projects"></i>
        <p class="vr360-head-h2 vr360-text-gray-2">No public streams yet</p>
        <router-link :to="{ name: 'ListMyStreams' }" class="vr360-btn vr360-btn--red">
          <span>Go live</span>
        </router-link>
      </template>
      <template v-if="status === 'success' && streams.length === 0 && !!search">
        <i class="vr360-icon bg-not-found"></i>
        <p class="vr360-text-reg vr360-text-gray-3">We did not find results for this search</p>
      </template>
    </template>
    <template v-else>
      <i class="vr360-icon bg-no-connected"></i>
      <p
        class="vr360-text-reg vr360-text-gray-3"
      >Slow or not internet connections. Please check your internrt settings</p>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ItemPublicStream from "./listStreams/ItemPublicStreamInList";
import Refresh from "@/components/partials/Refresh";

export default {
  name: "listPublicStreams",
  components: {
    ItemPublicStream,
    Refresh
  },
  created() {
    setTimeout(() => {
      if (!this.status) {
        const scope = "public";
        const filter = this.$route.query.filter || "all";

        this.changeScope(scope);
        this.changeFilter(filter);
        this.changeSearch("");

        const updatedQuery = { ...this.$route.query, ...{ filter } };
        this.$router.push({ query: updatedQuery });

        setTimeout(() => {
          if (!this.status && this.isAuthenticated) {
            this.fetchStreams();
          }
        }, 50);
      }
    }, 0);
  },
  mounted() {
    requestAnimationFrame(() => {
      this.scroll();
    });
  },
  beforeDestroy() {
    if (this.getScrollBlock)
      this.getScrollBlock.removeEventListener("scroll", this.handlerScroll);
  },
  methods: {
    ...mapActions({
      fetchStreams: "stream/fetchStreams",
      clearStreams: "stream/clearStreams",
      logoutUser: "user/logoutUser",
      changeScope: "stream/changeScope",
      changeFilter: "stream/changeFilter",
      changeSearch: "stream/changeSearch",
      setPositionScrollY: "setPositionScrollY"
    }),
    scroll() {
      this.getScrollBlock.addEventListener("scroll", this.handlerScroll);
      this.getScrollBlock.scrollTop = this.getPositionScrollY;
    },
    handlerScroll(e) {
      const target = e.target;
      let bottomOfWindow =
        target.scrollTop + target.offsetHeight === target.scrollHeight;

      // let topOfWindow = document.documentElement.scrollTop === 0;

      if (bottomOfWindow && !this.endOfList) {
        this.fetchStreams();
      }
    },
    refreshList() {
      this.clearStreams();
      this.fetchStreams();
    }
  },
  watch: {
    "$route.query.filter"(val) {
      this.getScrollBlock.removeEventListener("scroll", this.handlerScroll);
      this.changeFilter(val);

      this.fetchStreams();
    },
    streams(val) {
      if (val.length > 0) {
        this.getScrollBlock.addEventListener("scroll", this.handlerScroll);
      }
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "user/isAuthenticated",
      streams: "stream/streamsList",
      page: "stream/streamsListPage",
      filter: "stream/streamsListFilter",
      search: "stream/streamsListSearch",
      endOfList: "stream/endOfList",
      getPositionScrollY: "getPositionScrollY",
      getScrollBlock: "getScrollBlock",
      status: "stream/status",
      connected: "connected"
    }),
    parentClass() {
      return {
        "vr360-app-main__all-streams":
          this.status === "success" &&
          this.streams.length >= 1 &&
          this.connected,
        "vr360-flex-column vr360-app-main__empty-state":
          (this.status === "success" &&
            this.streams.length < 1 &&
            this.connected) ||
          !this.connected
      };
    }
  }
};
</script>

<style lang="scss">
</style>
